/* _customled-ig-video-defer.js - Custom LED owned (M8.4, 2026-10-11)
 *
 * Stamped's Instagram feed renders each VIDEO post as a tile containing
 * <video preload="metadata"><source src="..._high.mp4#t=0.1"></video> (the video doubles as its own thumbnail;
 * there is no image). Every tile starts downloading as soon as Stamped renders the feed - on a PDP
 * ~10-16 videos x 2.5-4.6 MB, even for visitors who never scroll down to the feed.
 *
 * This script lazy-loads those tile videos the same way Stamped lazy-loads its photo tiles: the src is
 * held back (data-cl-src) as Stamped inserts each tile, and restored when the tile comes within 300px
 * of the viewport (Stamped's own lazy-load threshold), horizontally too - carousel tiles off to the side
 * stay unloaded until paged into view. Visitors see the same thumbnail frames as before; the bytes are
 * only spent on tiles that are actually viewed. The click popup builds its own <video> from Stamped's
 * data, so it is unaffected. No Stamped API is called (July: poking reloadUGC broke /fr reviews).
 * Fails open: without IntersectionObserver, or on any error, the original src is left in place.
 */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var v = e.target;
      io.unobserve(v);
      restore(v);
    });
  }, { rootMargin: '300px' });

  function restore(v) {
    [v].concat(Array.prototype.slice.call(v.querySelectorAll('source'))).forEach(function (el) {
      var s = el.getAttribute('data-cl-src');
      if (s) { el.setAttribute('src', s); el.removeAttribute('data-cl-src'); }
    });
    v.preload = 'metadata';
    v.load();
  }
  function hold(v) {
    try {
      if (v.classList.contains('stamped-ugc-modal-video')) return;      // popup player: never touch
      if (!v.closest('.stamped-instagram-media-block')) return;
      // Stamped emits <video><source src="..." type="video/mp4"></video>; handle a direct src too.
      var els = [v].concat(Array.prototype.slice.call(v.querySelectorAll('source')));
      var held = 0;
      els.forEach(function (el) {
        var s = el.getAttribute('src');
        if (s) { el.setAttribute('data-cl-src', s); el.removeAttribute('src'); held++; }
      });
      if (!held) return;
      v.preload = 'none';
      v.load();                                                           // abort a fetch already queued
      io.observe(v);
    } catch (err) { /* fail open */ }
  }
  function scan(n) {
    if (n.tagName === 'VIDEO') { hold(n); return; }
    if (n.tagName === 'SOURCE' && n.parentNode && n.parentNode.tagName === 'VIDEO') { hold(n.parentNode); return; }
    if (n.querySelectorAll) Array.prototype.forEach.call(n.querySelectorAll('video'), hold);
  }
  function watch(feed) {
    scan(feed);
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(feed, { childList: true, subtree: true });
  }
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-widget-type="instagram-feed"]'), watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
